import React from 'react'
import './cat.css'
import cat from './cat.svg'

export class Cat extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <div className="Cat">
                <img src={cat} alt="" />
            </div>
        )
    }
}
